var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1216_2144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8404 7.66875C14.8404 7.175 14.7967 6.70625 14.7217 6.25H7.65918V9.06875H11.7029C11.5217 9.99375 10.9904 10.775 10.2029 11.3063V13.1813H12.6154C14.0279 11.875 14.8404 9.95 14.8404 7.66875Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65957 14.9984C9.68457 14.9984 11.3783 14.3234 12.6158 13.1797L10.2033 11.3047C9.52832 11.7547 8.67207 12.0297 7.65957 12.0297C5.70332 12.0297 4.04707 10.7109 3.45332 8.92969H0.96582V10.8609C2.19707 13.3109 4.72832 14.9984 7.65957 14.9984Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45293 8.93437C3.29668 8.48437 3.21543 8.00312 3.21543 7.50312C3.21543 7.00312 3.30293 6.52188 3.45293 6.07188V4.14062H0.965429C0.452929 5.15313 0.15918 6.29062 0.15918 7.50312C0.15918 8.71562 0.452929 9.85312 0.965429 10.8656L3.45293 8.93437Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65957 2.96875C8.76582 2.96875 9.75332 3.35 10.5346 4.09375L12.6721 1.95625C11.3783 0.743751 9.68457 0 7.65957 0C4.72832 0 2.19707 1.6875 0.96582 4.1375L3.45332 6.06875C4.04707 4.2875 5.70332 2.96875 7.65957 2.96875Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1216_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fa4d59e02e436d98ec64141fbf00da5c.svg";
export { ForwardRef as ReactComponent };